var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.user_type == 'people')?_c('b-icon',{attrs:{"icon":"account","size":_vm.size}}):_c('b-icon',{attrs:{"icon":"package-variant-closed","size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }